module.exports = __webpack_public_path__ + "media/newstyle/images/psychology-206da0e608361d246ae4e07f29079827.svg";